// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H9V4H4V9H2V2ZM15 2H22V9H20V4H15V2ZM8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12ZM4 15V20H9V22H2V15H4ZM22 15V22H15V20H20V15H22Z"}}]};

const CenterFocusStrongFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'center-focus-strong-filled',
    ref,
    icon: element,
  },
));

CenterFocusStrongFilledIcon.displayName = 'CenterFocusStrongFilledIcon';

export default CenterFocusStrongFilledIcon;
